import { Injectable } from "@angular/core";
import { InviteMemberConnector } from "./invite-member.connector";
import { AppServerInviteMemberConnector } from "../../app-server-connectors";
import { AuthenticationService, CachingService, IAMService, UIService } from "src/app/services/services.module";
import { APIResponse, InviteMemberDocument, InviteUserUpdate, OrganisationMemberDocument } from "server-model";

@Injectable()
export class InviteMemberDataService {
    private inviteMemberConnector: InviteMemberConnector;

    constructor(
        private cachingService: CachingService,
        private iamService: IAMService,
        private authenticationService: AuthenticationService,
        private uiService: UIService,
    ) {
        this.inviteMemberConnector = new AppServerInviteMemberConnector(this.iamService, this.authenticationService, this.uiService)
    }

    async getInvite(token: string): Promise<APIResponse> {
        return await this.inviteMemberConnector.getInvite(token)
    }

    async createInvite(organisationId: string, inviteMemberDocument: InviteMemberDocument): Promise<APIResponse> {
        return await this.inviteMemberConnector.createInvite(organisationId, inviteMemberDocument)
    }

    async resendInvite(email: string, organisationId: string): Promise<APIResponse> {
        return await this.inviteMemberConnector.resendInvite(email, organisationId)
    }

    async deleteInvite(email: string, organisationId: string): Promise<APIResponse> {
        return await this.inviteMemberConnector.deleteInvite(email, organisationId)
    }

    async updateUser(userId: string, inviteUserUpdate: InviteUserUpdate): Promise<APIResponse> {
        return await this.inviteMemberConnector.updateUser(userId, inviteUserUpdate)
    }
}
